<script lang="ts">
  import { telemetryAlert } from '../../lib/telemetry';

  // Discreet, dismissible, fixed to the bottom so it works on every page —
  // including the cream Vidamor letter. Shows the short diagnostics code a
  // non-technical user can read aloud; the matching batch is already in
  // Convex by the time they do (specs/observability).
  let dismissed = false;

  $: alert = $telemetryAlert;
  $: if (!alert) dismissed = false;
</script>

{#if alert && !dismissed}
  <div class="diagnostics-banner" role="alert">
    <span class="diagnostics-banner__text">
      something glitched. if it keeps happening, tell us this code:
      <strong class="diagnostics-banner__code">{alert.code}</strong>
    </span>
    <button
      type="button"
      class="diagnostics-banner__dismiss"
      aria-label="Dismiss"
      on:click={() => (dismissed = true)}
    >
      ×
    </button>
  </div>
{/if}

<style>
  .diagnostics-banner {
    /* left/right + auto margins (not left:50% + transform): a fixed element's
       shrink-to-fit width is measured from its inset, which would halve the
       available width and over-wrap the text. */
    position: fixed;
    left: 0;
    right: 0;
    bottom: var(--space-4);
    margin-inline: auto;
    width: fit-content;
    z-index: var(--z-toast);
    display: flex;
    align-items: center;
    gap: var(--space-3);
    max-width: min(92vw, 480px);
    padding: var(--space-3) var(--space-4);
    background: var(--color-surface-950);
    color: var(--color-text-secondary);
    border: var(--border-subtle);
    border-left: 3px solid var(--color-accent);
    font-family: var(--font-mono);
    font-size: var(--font-size-sm);
    line-height: var(--line-height-normal);
  }

  .diagnostics-banner__code {
    color: var(--color-text-primary);
    letter-spacing: 0.15em;
  }

  /* Explicit width/reset: the mobile system.css rule stretches bare buttons
     to 100% (see docs/vidamor.md gotchas). */
  .diagnostics-banner__dismiss {
    width: auto;
    border: none;
    background: transparent;
    color: var(--color-text-secondary);
    font-size: var(--font-size-lg);
    line-height: 1;
    padding: 0 var(--space-1);
    cursor: pointer;
  }

  .diagnostics-banner__dismiss:hover {
    color: var(--color-text-primary);
  }
</style>
